import React from "react";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Backpack03Icon,
  Home03Icon,
  ProfileIcon,
  ShoppingBag01Icon,
} from "@hugeicons/core-free-icons";
import { useNavigate } from "react-router";
const FloatingBar = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full p-2 bg-white fixed bottom-0 block lg:hidden drop-shadow-xl z-30">
      <div className="grid grid-cols-4 gap-1">
        <div
          onClick={() => navigate("/")}
          className="flex flex-col justify-center items-center bg-white active:bg-[#d1eaff] duration-300 transition-all scale-100 active:scale-95 p-1 rounded-lg select-none"
        >
          <HugeiconsIcon icon={Home03Icon} />
          <p className="text-xs">Home</p>
        </div>
        <div
          onClick={() => navigate("/offers")}
          className="flex flex-col justify-center items-center bg-white active:bg-[#d1eaff] duration-300 transition-all scale-100 active:scale-95 p-1 rounded-lg select-none"
        >
          <HugeiconsIcon icon={ShoppingBag01Icon} />
          <p className="text-xs">Offers</p>
        </div>
        <div
          onClick={() => navigate("/tours")}
          className="flex flex-col justify-center items-center bg-white active:bg-[#d1eaff] duration-300 transition-all scale-100 active:scale-95 p-1 rounded-lg select-none"
        >
          <HugeiconsIcon icon={Backpack03Icon} />
          <p className="text-xs">Tours</p>
        </div>
        <div
          onClick={() => navigate("/customer/dashboard")}
          className="flex flex-col justify-center items-center bg-white active:bg-[#d1eaff] duration-300 transition-all scale-100 active:scale-95 p-1 rounded-lg select-none"
        >
          <HugeiconsIcon icon={ProfileIcon} />
          <p className="text-xs">Account</p>
        </div>
      </div>
    </div>
  );
};

export default FloatingBar;
